import { Instagram, Linkedin, Mail } from "lucide-react";
import { useRevealAnimation } from "@/motion/hooks";
import { SITE } from "@/config";

export default function Footer() {
    const year = new Date().getFullYear();
    const revealRef = useRevealAnimation("fadeUp");
    return (
        <footer ref={revealRef} className="border-t border-[color:var(--line)] bg-[#030303]">
            <div className="mx-auto flex max-w-[1400px] flex-col items-center gap-6 px-6 md:px-10 py-12 md:flex-row md:justify-between">
                <div className="text-center md:text-left">
                    <p className="font-display text-2xl">Nikhil Joshi</p>
                    <p className="mt-1 text-[10px] uppercase tracking-luxe text-[color:var(--muted)]">
                        AI Visual Creator &amp; Video Editor · {SITE.locality}
                    </p>
                </div>

                <div className="flex items-center gap-6">
                    <a
                        href={`mailto:${SITE.email}`}
                        aria-label="Email"
                        className="text-[color:var(--fg)]/70 hover:text-[color:var(--gold)] transition-colors"
                    >
                        <Mail size={18} />
                    </a>
                    <a
                        href={SITE.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                        className="text-[color:var(--fg)]/70 hover:text-[color:var(--gold)] transition-colors"
                    >
                        <Instagram size={18} />
                    </a>
                    <a
                        href={SITE.linkedin}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="LinkedIn"
                        className="text-[color:var(--fg)]/70 hover:text-[color:var(--gold)] transition-colors"
                    >
                        <Linkedin size={18} />
                    </a>
                </div>

                <p className="text-[10px] uppercase tracking-[0.2em] text-[color:var(--muted)]">
                    © {year} createwithnikhil
                </p>
            </div>
        </footer>
    );
}
